import React, { useEffect, useState } from "react";
import CountUp from "react-countup";

import { Container } from "./styles";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";
import Status from "../../../components/status";
import {
  Card,
  HeaderTitle,
  Message,
  Table,
  ViewInput,
} from "../../../GlobalStyles";

import { getDate } from "../../../services/functions";
import { addDays, format } from "date-fns";
import { Button, Pagination, Spin, DatePicker, Select } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import { useQuery } from "../../../hooks/Location";
import { MdAccountBalance } from "react-icons/md";

const PagamentosAdmin = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const [users, setUsers] = useState([]);
  const [payments, setPayments] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [paymentsTotal, setPaymentsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [user_id, setUser_id] = useState(query.get("cliente") || "");
  const [status, setStatus] = useState("");
  const [method, setMethod] = useState("");
  const [type, setType] = useState("");
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadPayments(page);
  }, [page]);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadPayments(page) {
    setIsLoading(true);
    await api
      .get(`/admin/payments?page=${page}`)
      .then((response) => {
        setPayments(response.data.payments);
        setTotalValue(response.data.totalValue);
        setPaymentsTotal(response.data.paymentsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Todos Pagamentos</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => {
            navigate("/admin/pacotes");
          }}
        >
          <MdAccountBalance size="20" color="#fff" />
          Pacotes de Deposito
        </Button>
      </HeaderTitle>

      {!isLoading && (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={paymentsTotal} />
          </Card>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              marginBottom: 20,
            }}
          >
            <ViewInput
              style={{ width: "100%", maxWidth: 265, marginRight: 15 }}
            >
              <p>Selecione o Periodo</p>
              <DatePicker.RangePicker
                placeholder={["data inicial", "data final"]}
                value={[
                  startDate ? dayjs(startDate) : "",
                  endDate ? dayjs(endDate) : "",
                ]}
                locale={locale}
                format={"DD/MM/YYYY"}
                onChange={(value, dateString) => {
                  setStartDate(getDate(dateString[0]));
                  setEndDate(getDate(dateString[1]));
                  setPage(0);
                }}
                allowClear={false}
                style={{ width: 265 }}
                onOk={() => {}}
              />
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 200, marginRight: 15 }}
            >
              <p>Filtrar por Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Franqueados</Select.Option>
                {users.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 150, marginRight: 15 }}
            >
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="pendente">Pendente</Select.Option>
                <Select.Option value="confirmado">Confirmado</Select.Option>
                <Select.Option value="cancelado">Cancelado</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 150, marginRight: 15 }}
            >
              <p>Filtrar por Método</p>
              <Select
                placeholder="selecionar status"
                value={method}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setMethod(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="PIX">PIX</Select.Option>
                <Select.Option value="SALDO">Saldo</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 175 }}>
              <p>Filtrar por Tipo</p>
              <Select
                placeholder="selecionar status"
                value={type}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setType(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="OS">Ordem de Serviço</Select.Option>
                <Select.Option value="LEAD">Compra de Lead</Select.Option>
                <Select.Option value="DEPOSIT">Deposito de Saldo</Select.Option>
              </Select>
            </ViewInput>
          </div>
          {!!totalValue && (
            <h4 style={{ marginTop: 0, marginBottom: -15 }}>
              {" "}
              {totalValue.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}{" "}
              total em pagamentos
            </h4>
          )}
          {!!paymentsTotal ? (
            <Table>
              <thead>
                <tr>
                  <td>Tipo</td>
                  <td>Valor</td>
                  <td>Método</td>
                  <td>Status</td>
                  <td>Ultima atualização</td>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment) => {
                  return (
                    <tr key={payment.id}>
                      <td
                        onClick={() => {
                          if (payment.type == "OS") {
                            navigate(`/admin/os/${payment.order_id}`);
                          }
                        }}
                        style={{
                          fontWeight: "800",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        <Button type="primary" style={{ height: 25 }}>
                          {payment.type == "OS"
                            ? `OS: ${payment.order_id}`
                            : payment.type == "LEAD"
                            ? `VER LEAD`
                            : "VER DEPOSITO"}
                        </Button>
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {(payment.value || 0).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </td>
                      <td>{payment.method}</td>
                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Status
                          status={payment.status}
                          isPayment={true}
                          style={{
                            fontSize: 11,
                            height: 20,
                            paddingBottom: 2,
                          }}
                        />
                      </td>
                      <td>
                        {format(
                          new Date(payment.update_at),
                          "dd/MM/yyyy HH:mm"
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <Message style={{ marginTop: 40 }}>
              Nenhum pagamento encontrado
            </Message>
          )}
        </>
      )}

      <Pagination
        style={{ marginTop: 15, alignSelf: "center" }}
        defaultCurrent={page + 1}
        onChange={(page) => {
          setPage(page - 1);
        }}
        total={paymentsTotal}
        pageSize={30}
      />
    </Container>
  );
};

export default PagamentosAdmin;
